import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import ListTypePractice from 'practice/components/shared/list-type-practice';
import {
  ResearchResponsibleFilterVM,
  ResearchResponsibleVM,
} from 'practice/view-models/research-responsible';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchResponsibleVM>();

  const onChange = useEventCallback(
    (
      key: keyof ResearchResponsibleFilterVM,
      value: ResearchResponsibleFilterVM[keyof ResearchResponsibleFilterVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  const handleListTypePracticeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typePractice', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Codice responsabile"
          aria-label="Codice responsabile"
          fullWidth
          id="codeResponsible"
          name="codeResponsible"
          value={formContext.values.filter?.codeResponsible || ''}
          onChange={(event) => onChange('codeResponsible', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchResponsibleFilterVM>)
              ?.codeResponsible &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchResponsibleFilterVM>)
                ?.codeResponsible
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchResponsibleFilterVM>)
              ?.codeResponsible
          }
          inputProps={{
            maxLength: '6',
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListTypePractice
          value={formContext.values?.filter?.typePractice || ''}
          onChange={handleListTypePracticeChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchResponsibleFilterVM>)
              ?.typePractice &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchResponsibleFilterVM>)?.typePractice
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Codice servizio"
          aria-label="Codice servizio"
          fullWidth
          id="codeService"
          name="codeService"
          value={formContext.values.filter?.codeService || ''}
          onChange={(event) => onChange('codeService', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchResponsibleFilterVM>)
              ?.codeService &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchResponsibleFilterVM>)?.codeService
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchResponsibleFilterVM>)?.codeService
          }
          inputProps={{
            maxLength: '4',
          }}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
